export const locale = {
    lang: 'es',
    data: {
        FORM_DYNAMIC: {
            DATE_FORMAT: 'dd/MM/yyyy',
        },
    },
};
